import Vue from 'vue';
import VueRouter from 'vue-router';
import {
    ValidationProvider, ValidationObserver,
} from 'vee-validate';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';
import './directives';

import '@/assets/scss/base.scss';

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.use(VueRouter);

new Vue({
    render: (h) => h(App),
    router,
    store,
    i18n,
}).$mount('#app');
